<fieldset *ngIf="form">
    <form-address-country
        [formCountry]="form.get('country')"
        (selectChange)="addressFromPostal()"
        [orderworkTemplate]="orderworkTemplate"
    ></form-address-country>

    <form-address-location
        [formAddress]="form"
        [postalLoading]="postalLoading"
        (postalUserDontKnow)="postalUserDontKnow()"
        (addressBlur)="addressFromPostal()"
    ></form-address-location>

    <div class="form-group row" *ngIf="message.notFound">
        <form-address-unknown-warning></form-address-unknown-warning>
    </div>

    <ng-container *ngIf="hasRemovalInfo">
        <h5 class="card-title mt-2" i18n="@@addressDetails_label_info" app-i18n="addressDetails_label_info">Verhuisinformatie</h5>

        <form-address-floor [formFloor]="form.get('floor')" [formMoveType]="form.get('moveType')"></form-address-floor>

        <div class="mb-3" *ngIf="form.value.floor > 0">
            <div class="form-check form-switch">
                <input
                    [formControl]="form.get('liftInternal')"
                    type="checkbox"
                    class="form-check-input"
                    id="liftInternal"
                    (change)="setMoveType()"
                />
                <div class="input-group input-group-sm d-flex align-items-center">
                    <label
                        class="form-check-label text-muted"
                        for="liftInternal"
                        data-cy="liftInternal"
                        i18n="@@addressDetails_moveMethod_question_liftInternal"
                        app-i18n="addressDetails_moveMethod_question_liftInternal"
                    >
                        Interne lift aanwezig?
                    </label>
                    <span class="ms-2">
                        <information-icon [className]="'text-info'" [size]="'sm'" (click)="$event.stopPropagation()">
                            <h3
                                header
                                i18n="@@addressDetails_moveMethod_infoHeader_liftInternal"
                                app-i18n="addressDetails_moveMethod_infoHeader_liftInternal"
                            >
                                Geen interne lift?
                            </h3>
                            <span
                                body
                                i18n="@@addressDetails_moveMethod_infoBody_liftInternal"
                                app-i18n="addressDetails_moveMethod_infoBody_liftInternal"
                                >Indien er geen interne lift aanwezig is en je geen verhuislift selecteert in stap 4, zullen wij je
                                verhuizing uitvoeren via de trap.</span
                            >
                        </information-icon>
                    </span>
                </div>
            </div>
        </div>

        <form-floating>
            <label i18n="@@addressDetails_workDescription_label" app-i18n="addressDetails_workDescription_label"
                >Omschrijving werkzaamheden (optioneel)</label
            >
            <textarea
                class="form-control"
                [style.height]="'200px'"
                [formControl]="form.get('description')"
                placeholder="Hier kun je extra informatie kwijt over wat er moet gebeuren op dit adres"
                i18n-placeholder="@@addressDetails_workDescription_place"
                [attr.placeholder]="i18n('addressDetails_workDescription_place')"
                input-validation
                autocomplete="off"
            ></textarea>
            <div help-text i18n="@@addressDetails_workDescription_helpText" app-i18n="addressDetails_workDescription_helpText">
                Hier kun je extra informatie kwijt over wat er moet gebeuren op dit adres
            </div>
        </form-floating>
    </ng-container>
</fieldset>
